var _path, _circle, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.089 19.3592C38.089 29.8526 29.5824 38.3592 19.089 38.3592C-2.41112 39.8592 0.0890106 29.8526 0.0890106 19.3592C0.0890106 8.86581 8.08887 1.58139 19.089 0.359221C41.5889 -2.14062 38.089 8.86581 38.089 19.3592Z",
    fill: "#F2EA17"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.9318,
    cy: 11.1935,
    r: 5.19351,
    stroke: "#313132",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64167 30.0764C9.64167 30.0764 9.23733 25.4636 11.577 22.7214C13.2995 20.7024 17.3958 20.3065 19.7061 20.399C21.8585 20.4852 25.1199 20.8064 26.6736 22.7214C28.8986 25.4636 28.9964 30.0764 28.9964 30.0764",
    stroke: "#313132",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.0f717b721473673485600319fc515c18.svg";
export { ForwardRef as ReactComponent };